const Config ={
 API_URL:"https://apicrowd.hobo.video",
}

export {Config}
